import React from 'react'
import CloseRounded from '@mui/icons-material/CloseRounded'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { useVehicle } from 'contexts'

const VehicleSheetSellerObservation = () => {
  const { observationsVendeur } = useVehicle()
  const [isOpen, setIsOpen] = React.useState(false)
  const observation = observationsVendeur?.trim() ?? ''
  const canExpand = observation.length > 140

  return (
    <section className="vehicle-sheet-card vehicle-sheet__observations">
      <h2 className="vehicle-sheet__subsection-title">Observations vendeur</h2>
      {observation ? (
        <>
          <p className="vehicle-sheet__observation-preview">{observation}</p>
          {canExpand && (
            <button
              type="button"
              className="vehicle-sheet__text-action"
              onClick={() => setIsOpen(true)}
            >
              Lire l’observation complète
            </button>
          )}
          <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="seller-observation-title"
          >
            <DialogTitle
              id="seller-observation-title"
              className="vehicle-sheet__dialog-title"
            >
              Observations vendeur
              <IconButton
                aria-label="Fermer les observations"
                onClick={() => setIsOpen(false)}
                size="small"
              >
                <CloseRounded />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <p className="vehicle-sheet__observation-full">{observation}</p>
            </DialogContent>
          </Dialog>
        </>
      ) : (
        <p className="vehicle-sheet__empty-state">Aucune observation renseignée</p>
      )}
    </section>
  )
}

export default VehicleSheetSellerObservation
